import { ReactNode } from 'react'

export type Media =
  | { type: 'image'; src: string }
  | { type: 'video'; src: string }

export const ShopDetails: Record<
  string,
  {
    title: string
    description: string
    mainMedia?: Media
    content?: ReactNode
    gallery?: string[]
  }
> = {
  '1': {
    title: 'Uncle Bowl Southport',
    description:
      'Completed in 2024, Uncle Bowl Southport is a shop fit-out for a casual, healthy dining space. The project transformed a retail tenancy into a modern and functional restaurant designed for fast service and high customer turnover.',
    mainMedia: {
      type: 'image',
      src: '/UB-SP0.webp',
    },
    content: (
      <section className="space-y-4 font-Ovo text-gray-800 leading-relaxed">

        <div className="space-y-2">
          <p>📍 <strong>Location:</strong> Southport, QLD</p>
          <p>🏬 <strong>Project Type:</strong> Hospitality Shop Fitout</p>
          <p>🗓️ <strong>Completion:</strong> 2024</p>
        </div>

        <p className="font-semibold">
           Works included custom joinery, feature lighting, and durable interior finishes, delivered efficiently by a Queensland-based local builder.
        </p>
      </section>
    ),
    gallery: [
      '/UB-SP0.webp',
      '/UB-SP1.webp',
      '/UB-SP2.webp',
      '/UB-SP3.webp',
    ],
  },

  '2': {
    title: 'Hannok Toowoomba',
    description:
      ' Completed in 2026, Hannok Toowoomba is a shop fit-out that turned an existing retail tenancy into a sleek, functional restaurant space, optimised for daily operations and customer comfort.',
    mainMedia: {
      type: 'video',
      src: '/hk.webm',
    },
     content: (
      <section className="space-y-4 font-Ovo text-gray-800 leading-relaxed">

        <div className="space-y-2">
          <p>📍 <strong>Location:</strong> Toowoomba city, QLD</p>
          <p>🏬 <strong>Project Type:</strong> Hospitality Shop Fitout</p>
          <p>🗓️ <strong>Completion:</strong> 2026</p>
        </div>

        <p className="font-semibold">
          Delivered by a Queensland local builder, the project featured custom joinery, feature lighting, and quality interior finishes, completed within a tight programme.
        </p>
      </section>
    ),
    gallery: [
      '/hk/hk3.webp',
      '/hk/hk10.webp',
      '/hk/hk9.webp',
      '/hk/hk12.webp',
      '/hk/hk11.webp',
      '/hk/hk7.webp',
      '/hk/hk2.webp',
      '/hk/hk5.webp',
      '/hk/hk4.webp',
      '/hk/hk14.webp',
      '/hk/hk1.webp',
      '/hk/hk8.webp',
      '/hk/hk6.webp',
      '/hk/hk13.webp',
      '/hk/hk15.webp',
      '/hk/hk16.webp',
    ],
  },

  '3': {
    title: 'Uncle Bowl Chermside',
    description:
      ' Completed in 2026, Uncle Bowl Chermside is a shop fit-out for a quick-service dining concept. The design focused on functional layout, efficient workflow, and a welcoming atmosphere for customers. (Please check back soon for updates.)',
    mainMedia: {
      type: 'image',
      src: '/UB-C1.jpg',
    },
    content: (
  <section className="space-y-4 font-Ovo text-gray-800 leading-relaxed">
    <div className="space-y-2">
      <p>📍 <strong>Location:</strong> Chermside, QLD</p>
      <p>🏬 <strong>Project Type:</strong> Hospitality Shop Fit-Out</p>
      <p>🗓️ <strong>Completion:</strong> 2026</p>
    </div>

    <p className="font-semibold">
      The scope included internal fit-out works, custom joinery, service coordination, and interior finishes, delivered by a Queensland-based local builder.
    </p>
  </section>
    ),
     gallery: [
      '/UB-C1.jpg',   
    ],
  },
}





